import { createI18n } from 'vue-i18n'
import en from '../locales/en.json'
import nl from '../locales/nl.json'

// Number formatting utilities
export const formatNumber = (number, locale = 'en') => {
  if (locale === 'nl') {
    return number.toString().replace(/\./g, ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  }
  return number.toLocaleString('en-US')
}

// Get browser language with whitelabel preference or fallback to Dutch (primary market)
function getDefaultLocale() {
  const saved = localStorage.getItem('battcon-locale')
  if (saved && ['en', 'nl'].includes(saved)) {
    return saved
  }

  return 'nl'; // For now always Dutch, todo: need to fix language switching from configuration.

  // // Check if whitelabel service is available and has language preference
  // if (typeof window !== 'undefined' && window.whitelabelService) {
  //   try {
  //     const preferred = window.whitelabelService.getPreferredLanguage()
  //     if (preferred && ['en', 'nl'].includes(preferred)) {
  //       return preferred
  //     }
  //   } catch (error) {
  //     console.warn('Could not get whitelabel language preference:', error)
  //   }
  // }

  // const browserLang = navigator.language.toLowerCase()
  // if (browserLang.startsWith('en')) return 'en'
  // if (browserLang.startsWith('nl')) return 'nl'

  // // Default to Dutch as primary market
  // return 'nl'
}

const i18n = createI18n({
  legacy: false, // Use Composition API
  locale: getDefaultLocale(),
  fallbackLocale: 'nl',
  messages: {
    en,
    nl
  },
  numberFormats: {
    en: {
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      },
      currency: {
        style: 'currency',
        currency: 'EUR',
        notation: 'standard'
      },
      percent: {
        style: 'percent',
        useGrouping: false
      }
    },
    nl: {
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      },
      currency: {
        style: 'currency',
        currency: 'EUR',
        notation: 'standard'
      },
      percent: {
        style: 'percent',
        useGrouping: false
      }
    }
  },
  datetimeFormats: {
    en: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long'
      }
    },
    nl: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long'
      }
    }
  }
})

export default i18n